(() => {
  if (customElements.get('velvet-home')) return;
  class VelvetHome extends HTMLElement {
    connectedCallback() {
      if (this.dataset.animate !== 'true' || window.Shopify?.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.dataset.vhAnimate = 'true';
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.style.setProperty('--delay', `${Number(entry.target.dataset.delay) || 0}ms`);
          entry.target.classList.add('visible');
          this.observer.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
      this.querySelectorAll('.reveal').forEach(element => this.observer.observe(element));
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }
  customElements.define('velvet-home', VelvetHome);
})();
